var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { stringBuilder } from '../util';
const TuxGlobalHeader = (props) => {
    const { children, className, fixed = false } = props, rest = __rest(props, ["children", "className", "fixed"]);
    const classes = stringBuilder('tuxedo_navbar', 'navbar', { fixed }, className);
    return (_jsx("header", Object.assign({}, rest, { className: classes, role: "banner" }, { children: children }), void 0));
};
export default TuxGlobalHeader;
